import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import { get } from 'lodash';
import { API_HOST } from '../../consts';
import { useEffect } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import HighchartSkill from './HighchartSkill';
import { Link } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { GeneralStudentStyleButton } from './style';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';

const ReportStudentSkillLevel = ({ match, history }) => {
  const [Atividades, setAtividades] = useState();
  const [habilidadeData, setHabilidadeData] = useState(undefined);
  const [boletimData, setBoletimData] = useState(undefined);
  const [loadingStudents, setLoadingStudents] = useState(true)
  const [loading, setLoading] = useState(true);
  const [matrizState, setMatrizState] = useState(1);
  const { filtrosRelatorios } = useContext(FilterRelatorioContext)

  const avaliaId = filtrosRelatorios.currentStudent;
  const periodoId = filtrosRelatorios.periodoAno;
  const theme = useContext(ThemeContext);

  const fetchHabilidade = () => {
    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho?idn=${avaliaId}&periodo_ano_id=${periodoId}`
    )
      .then((res) => {
        setLoadingStudents(false)
        setHabilidadeData(res.data.results);
      })
      .catch((err) => console.error(err));
  };

  const fetchBoletimData = () => {
    Axios.get(
      `${API_HOST}/avalia/boletim_mt?idn=${avaliaId}&PERIODO_ANO_ID__id=${periodoId}`
    )
      .then((res) => {
        setBoletimData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const fetchAtividades = () => {
    Axios.get(`${API_HOST}/avaliacoes/avaliacao?ordering=-criado_em`)
      .then((res) => {
        setAtividades(res.data.results);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchHabilidade();
    fetchBoletimData();
    fetchAtividades();
  }, []);

  const getAtividades = (habilidade) => {
    const arrayAtv =
      Atividades &&
      Atividades.filter((atv) => atv.habilidade === habilidade).slice(0, 5);
    return arrayAtv;
  };

  const matrizMatematicaSesi = [
    {
      title: '-',
      text: 'SESI.EF05MA03.s.06 - Identificar e representar frações (menores e maiores que a unidade), associando-as ao resultado de uma divisão ou à ideia de parte de um todo, utilizando a reta numérica como recurso.'
    },
    {
      title: '-',
      text: 'SESI.EF05MA04.s.07 - Identificar frações equivalentes.'
    },
    {
      title: '-',
      text: 'SESI.EF04MA11.s.11 - Identificar regularidades em sequências numéricas compostas por múltiplos de um número natural.'
    },
    {
      title: '-',
      text: 'SESI.EF03MA10.s.10 - Identificar regularidades em sequências ordenadas de números naturais, resultantes da realização de adições ou subtrações sucessivas, por um mesmo número, descrever uma regra de formação da sequência e determinar elementos faltantes ou seguintes.'
    },
    {
      title: '-',
      text: 'SESI.EF04MA27.s.27 - Analisar dados apresentados em tabelas simples ou de dupla entrada e em gráficos de colunas ou pictóricos, com base em informações das diferentes áreas do conhecimento, e produzir texto com a síntese de sua análise.'
    },
    {
      title: '-',
      text: 'SESI.EF05MA16.s.14 - Associar figuras espaciais a suas planificações (prismas, pirâmides, cilindros e cones) e analisar, nomear e comparar seus atributos.'
    },
    {
      title: '-',
      text: 'SESI.EF03MA13.s.13 - Associar figuras geométricas espaciais (cubo, bloco retangular, pirâmide, cone, cilindro e esfera) a objetos do mundo físico e nomear essas figuras.'
    },
    {
      title: '-',
      text: 'SESI.EF06MA16.s.22 - Associar pares ordenados de números a pontos do plano cartesiano do 1º quadrante, em situações como a localização dos vértices de um polígono.'
    },
    {
      title: '-',
      text: 'SESI.EF08MA22.s.28 - Calcular a probabilidade de eventos, com base na construção do espaço amostral, utilizando o princípio multiplicativo, e reconhecer que a soma das probabilidades de todos os elementos do espaço amostral é igual a 1.'
    },
    {
      title: '-',
      text: 'SESI.EF06MA30.s.40 - Calcular a probabilidade de um evento aleatório, expressando-a por número racional (forma fracionária, decimal e percentual) e comparar esse número com a probabilidade obtida por meio de experimentos sucessivos.'
    },
    {
      title: '-',
      text: 'SESI.EF07MA10.s.12 - Comparar e ordenar números racionais em diferentes contextos e associá-los a pontos da reta numérica.'
    },
    {
      title: '-',
      text: 'SESI.EF08MA14.s.21 - Demonstrar propriedades de quadriláteros por meio da identificação da congruência de triângulos.'
    }
  ];
  const matrizLinguagensSesi = [
    {
      title: '-',
      text: 'SESI.EF67LP35.06.s.22 - Distinguir palavras derivadas por acréscimo de afixos e palavras compostas.'
    },
    {
      title: '-',
      text: 'SESI.EF04LP05.04.s.54 - Identificar a função na leitura e usar, adequadamente, na escrita ponto final, de interrogação, de exclamação, dois-pontos e travessão em diálogos (discurso direto), vírgula em enumerações e em separação de vocativo e de aposto.'
    },
    {
      title: '-',
      text: 'SESI.EF02LP10.02.s.72 - Identificar sinônimos de palavras de texto lido, determinando a diferença de sentido entre eles, e formar antônimos de palavras encontradas em texto lido pelo acréscimo do prefixo de negação in-/im-.'
    },
    {
      title: '-',
      text: 'SESI.EF67LP37.06.s.24 - Analisar, em diferentes textos, os efeitos de sentido decorrentes do uso de recursos linguístico-discursivos de prescrição, causalidade, sequências descritivas e expositivas e ordenação de eventos.'
    },
    {
      title: '-',
      text: 'SESI.EF06LP09.06.s.32 - Classificar, em texto ou sequência textual, os períodos simples compostos.'
    },
    {
      title: '-',
      text: 'SESI.EF09LP07.09.s.16 - Comparar o uso de regência verbal e regência nominal na norma-padrão com seu uso no português brasileiro coloquial oral.'
    },
    {
      title: '-',
      text: 'SESI.EF03LP08.03.s.53 - Identificar e diferenciar, em textos, substantivos e verbos e suas funções na oração: agente, ação, objeto da ação.'
    },
    {
      title: '-',
      text: 'SESI.EF35LP29.04.s.73 - Identificar, em narrativas, cenário, personagem central, conflito gerador, resolução e o ponto de vista com base no qual as histórias são narradas, diferenciando narrativas em primeira e terceira pessoas.'
    },
    {
      title: '-',
      text: 'SESI.EF07LP05.07.s.17 - Identificar, em orações de textos lidos ou de produção própria, verbos de predicação completa e incompleta: intransitivos e transitivos.'
    },
    {
      title: '-',
      text: 'SESI.EF35LP04.03.s.06 - Inferir informações implícitas nos textos lidos.'
    },
    {
      title: '-',
      text: 'SESI.EF69LP48.08.s.43 - Interpretar, em poemas, efeitos produzidos pelo uso de recursos expressivos sonoros (estrofação, rimas, aliterações etc), semânticos (figuras de linguagem, por exemplo), gráfico espacial (distribuição da mancha gráfica no papel), imagens e sua relação com o texto verbal.'
    },
    {
      title: '-',
      text: 'SESI.EF04LP04.04.a.25 - Reconhecer a estrutura de diferentes gêneros textuais, bem como os recursos expressivos neles utilizados para criar efeitos de sentido.'
    },
    {
      title: '-',
      text: 'SESI.EF04LP20.04.s.39 - Reconhecer a função de gráficos, diagramas e tabelas em textos, como forma de apresentação de dados e informações.'
    },
    {
      title: '-',
      text: 'SESI.EF07LP04.07.s.15 - Reconhecer, em textos, o verbo como o núcleo das orações.'
    }
  ];
  const MatrizMatematicaSaeb = [
    {
      title: 'NÚMEROS',
      text: 'H01 - Reconhecer o que os números naturais indicam em diferentes situações: quantidade, ordem, medida ou código de identificação.'
    },
    {
      title: 'NÚMEROS',
      text: 'H02 - Identificar a posição ordinal de um objeto ou termo de uma sequência (1º, 2º, etc).'
    },
    {
      title: 'NÚMEROS',
      text: 'H03 - Escrever números naturais de até 4 ordens (3 ordens para o 2º ano) em sua representação por algarismos ou em língua materna OU Associar o registro numérico de números naturais de até 4 ordens (3 ordens para o 2º ano) ao registro em língua materna.'
    },
    {
      title: 'NÚMEROS',
      text: 'H05 - Comparar OU Ordenar números naturais de até 4 ordens (3 para 2º ano), com ou sem suporte da reta numérica.'
    },
    {
      title: 'NÚMEROS',
      text: 'H08 - Calcular o resultado de adições ou subtrações, envolvendo números naturais de até 4 ordens (3 ordens para o 2º ano).'
    },
    {
      title: 'NÚMEROS',
      text: 'H10 - Resolver problemas de adição ou de subtração, envolvendo números naturais de até 4 ordens (3 ordens para o 2º ano), com os significados de juntar, acrescentar, separar ou retirar.'
    },
    {
      title: 'NÚMEROS',
      text: 'H14 - Identificar a classificação OU Classificar objetos ou representações por figuras, por meio de atributos, tais como cor, forma e medida.'
    },
    {
      title: 'ÁLGEBRA',
      text: 'H14 - Identificar a classificação OU Classificar objetos ou representações por figuras, por meio de atributos, tais como cor, forma e medida.'
    },
    {
      title: 'ÁLGEBRA',
      text: 'H16 - Inferir o padrão ou a regularidade de uma sequência de números naturais ordenados, de objetos ou de figuras.'
    },
    {
      title: 'ÁLGEBRA',
      text: 'H17 - Inferir os elementos ausentes em uma sequência de números naturais ordenados, de objetos ou de figuras.'
    },
    {
      title: 'GEOMETRIA',
      text: 'H18 - Identificar a localização OU a descrição/esboço do deslocamento de pessoas e/ou de objetos em representações bidimensionais (mapas, croquis, etc.).'
    },
    {
      title: 'GEOMETRIA',
      text: 'H19 - Reconhecer/nomear figuras geométricas espaciais (cubo, bloco retangular, pirâmide, cone, cilindro e esfera), relacionando-as com objetos do mundo físico.'
    },
    {
      title: 'GEOMETRIA',
      text: 'H20 - Reconhecer/nomear figuras geométricas planas (círculo, quadrado, rßetângulo e triângulo).'
    },
    {
      title: 'GRANDEZAS E MEDIDAS',
      text: 'H22 - Comparar comprimentos capacidades ou massas OU Ordenar imagens de objetos com base na comparação visual de seus comprimentos, capacidades ou massas.'
    },
    {
      title: 'GRANDEZAS E MEDIDAS',
      text: 'H26 - Identificar sequência de acontecimentos relativos a um dia.'
    },
    {
      title: 'GRANDEZAS E MEDIDAS',
      text: 'H28 - Relacionar valores de moedas e/ou cédulas do sistema monetário brasileiro, com base nas imagens desses objetos.'
    },
    {
      title: 'PROBABILIDADE E ESTATÍSTICA',
      text: 'H32 - Classificar resultados de eventos cotidianos aleatórios como “pouco prováveis”, “muito prováveis”, “certos” ou impossíveis”.'
    },
    {
      title: 'PROBABILIDADE E ESTATÍSTICA',
      text: 'H33 - Ler/identificar OU Comparar dados estatísticos ou informações expressos em tabelas (simples ou de dupla entrada).'
    }
  ];
  const MatrizLinguagensSaeb = [
    {
      title: 'LEITURA',
      text: 'H06 - Inferir o sentido de palavra ou expressão, selecionando aquela que pode substituí-la sem alterar o sentido do texto.'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      text: 'H04 - Segmentar palavras em sílabas e/ou remover e substituir sílabas iniciais, mediais ou finais para criar novas palavras.'
    },
    {
      title: 'LEITURA',
      text: 'H10 - Identificar, em textos versificados, rimas, sonoridades, jogos de palavras, palavras, expressões, comparações, relacionando-as com sensações e associações.'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      text: 'H02 - Ler e escrever corretamente as palavras com sílabas CV,V, CVC, CCV, identificando que existem vogais em todas as sílabas.'
    },
    { title: 'LEITURA', text: 'H13 - Distinguir fatos de opiniões em textos' },
    {
      title: 'LEITURA',
      text: 'H05 - Compreender o efeito de sentido decorrente do uso de diferentes pontuações (ponto final, de interrogação, de exclamação ou dois pontos).'
    },
    {
      title: 'LEITURA',
      text: 'H08 - Inferir informações implícitas em textos.'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      text: 'H01 - Relacionar elementos sonoros das palavras com sua representação escrita.'
    },
    { title: 'LEITURA', text: 'H09 - Identificar a finalidade de um texto.' },
    {
      title: 'LEITURA',
      text: 'H14 - Inferir informações em textos que articulam linguagem verbal e não verbal.'
    },
    {
      title: 'LEITURA',
      text: 'H07 - Localizar informações explícitas em textos.'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      text: 'H03 - Conhecer, diferenciar e relacionar letras em formato impressa e cursiva, maiúscula e minúscula.'
    }
  ];

  const titulo = [
    'Linguagens, Códigos e suas Tecnologias',
    'Matemática e suas Tecnologias'
  ];
  const cdDisciplina = boletimData && get(boletimData, 'CD_DISCIPLINA', '');
  const matriz =
    matrizState != 1 && matrizState == 2
      ? cdDisciplina == 1
        ? MatrizLinguagensSaeb
        : MatrizMatematicaSaeb
      : cdDisciplina == 1
        ? matrizMatematicaSesi
        : matrizLinguagensSesi;
  const host = window.location.hostname;
  return (
    <>
      {loading ? (
        <div
          style={{
            width: '100%',
            height: `100%`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={theme.loadingGif}
            alt="loading"
            style={{ height: '50px' }}
          />
        </div>
      ) : (
        <>
          <div
            className="card-header"
            style={{
              width:'100%',
              marginBottom: '-0.7rem',
              backgroundColor: '#f7f7f7',
              borderRadius: '10px'
            }}
          >
            <span
              style={{
                fontSize: '14px',
                color: '#292929',
                fontWeight: 500,
                fontFamily: 'Quicksand'
              }}
            >
              Desempenho por habilidade dos Estudantes
            </span>
            <hr
              style={{
                background: '#bebebe',
                width: '100%',
                height: '1px',
                borderRadius: '1px'
              }}
            />
          </div>
          <div
            className="card-body"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <div className="infos__school">
              <h2>Habilidades a serem desenvolvidas</h2>
              <span className="example-hability">
                Os dados abaixo dizem respeito ao desempenho dos estudantes dessa escola em cada habilidade testada. Demonstra a porcentagem de acertos de cada grupo de proficiência em uma habilidade.</span>
            </div>
            <div className="school__material">
              <span>
                {
                  titulo[
                  boletimData
                    ? get(boletimData, 'CD_DISCIPLINA', '') - 1
                    : ''
                  ]
                }
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                textAlign: 'left',
                width: '100%',
                fontSize: '18px',
                fontWeight: 'bold'
              }}
            >
              <span>
                {boletimData ? get(boletimData, 'NM_ALUNO', '') : ''}{' '}
                :
              </span>
              <div
                style={{
                  marginLeft: '1rem',
                  width: '40px',
                  height: '20px',
                  border: 'none',
                  borderRadius: '8px',
                  background: `${boletimData ? get(boletimData, 'cor', '') : '#fff'
                    }`
                }}
              ></div>
              <span style={{ margin: '1rem' }}>
                {boletimData
                  ? get(
                    boletimData,
                    'proficiencia_aluno',
                    'indefinida'
                  )
                  : 'indefinida'}
              </span>
            </div>
            <div className="table-proficiency">
              <span>
                {boletimData ? get(boletimData, 'NM_ETAPA', '') : ''}
              </span>
            </div>
            <hr className="pro-hr" />
                      {loadingStudents? (
                        <div
                        style={{
                          width: '100%',
                          height: `100%`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <img
                          src={theme.loadingGif}
                          alt="loading"
                          style={{ height: '50px' }}
                        />
                      </div>
                      ):(
                        <>
                {habilidadeData && matrizState === 1
              ? habilidadeData.map((dataHability) => {
                const sugestoesAtv = getAtividades(
                  dataHability.habilidade_id
                );
                return (
                  <div style={{ width: '100%' }}>
                    <div className="proeficiency__infos">
                      <>
                        <div className="axis__infos__SkillLevelPage">
                          <div className="axis__text">
                            <span>
                              Eixo de Conhecimento:{' '}
                              <span
                                style={{
                                  color: '#3C4583',
                                  marginLeft: '1rem',
                                  fontWeight: '500'
                                }}
                              >
                                {get(dataHability, 'eixo', '')}
                              </span>
                            </span>
                          </div>

                          <div className="habilidade">
                            <span>Habilidade: </span>
                            <span className="skill-text">
                              {get(dataHability, 'habilidade', '')}
                            </span>
                          </div>
                          <div className="intervencao-estudante">
                            <span>Sugestões de Atividades: </span>
                            {sugestoesAtv &&
                              sugestoesAtv.length > 0 ? (
                              <>
                                {sugestoesAtv.map((atv) => (
                                  <Link
                                    to={`/instrumentos-cognitivos/${atv.id}`}
                                  >
                                    {atv.nome}
                                  </Link>
                                ))}
                              </>
                            ) : (
                              <b>
                                Ainda não há atividades
                                relacionadas à esta habilidade
                              </b>
                            )}
                          </div>
                        </div>
                      </>
                      <div className="graphic">
                        <HighchartSkill data={dataHability} />
                      </div>
                    </div>
                  </div>
                );
              })
              : habilidadeData &&
              matriz.map((item, i) => {
                const dataHability = habilidadeData[i];
                const sugestoesAtv = getAtividades(
                  get(dataHability, 'id')
                );

                return (
                  <div style={{ width: '100%' }}>
                    <div className="proeficiency__infos">
                      <>
                        <div className="axis__infos__SkillLevelPage">
                          <div className="axis__text">
                            <span>
                              Eixo de Conhecimento:{' '}
                              <span
                                style={{
                                  color: '#3C4583',
                                  marginLeft: '1rem',
                                  fontWeight: '500'
                                }}
                              >
                                {item.title}
                              </span>
                            </span>
                          </div>

                          <div className="habilidade">
                            <span>Habilidade: </span>
                            <span className="skill-text">
                              {item.text}
                            </span>
                          </div>
                          <div className="intervencao-estudante">
                            <span>Sugestões de Atividades: </span>
                            {sugestoesAtv &&
                              sugestoesAtv.length > 0 ? (
                              <>
                                {sugestoesAtv.map((atv) => (
                                  <Link
                                    to={`/instrumentos-cognitivos/${atv.id}`}
                                  >
                                    {atv.nome}
                                  </Link>
                                ))}
                              </>
                            ) : (
                              <b>
                                Ainda não há atividades
                                relacionadas à esta habilidade
                              </b>
                            )}
                          </div>
                        </div>
                      </>
                      <div className="graphic">
                        {dataHability && (
                          <HighchartSkill data={dataHability} />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default withRouter(ReportStudentSkillLevel);
